import { render } from "./JudgesList.vue?vue&type=template&id=234784cf&scoped=true"
import script from "./JudgesList.vue?vue&type=script&lang=js"
export * from "./JudgesList.vue?vue&type=script&lang=js"

import "./JudgesList.vue?vue&type=style&index=0&id=234784cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234784cf"]])

export default __exports__